import { doc, getDoc } from "firebase/firestore";
import { getCentralFirebaseServices } from "./centralFirebase";

export class CentralTenantBootstrapRepository {
  constructor({ db = getCentralFirebaseServices().db } = {}) {
    this.db = db;
  }

  async getByTenantSlug(tenantSlug) {
    const snapshot = await getDoc(doc(this.db, "tenantBootstrap", tenantSlug));

    if (!snapshot.exists()) {
      return null;
    }

    return {
      id: snapshot.id,
      ...snapshot.data(),
    };
  }
}

export const createCentralTenantBootstrapRepository = (overrides) =>
  new CentralTenantBootstrapRepository(overrides);
